import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeAdcBoxTruckOrTruckLoadDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			deliveryMethod: '',
        }
    }

    closeDialog(event) {
        event && event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('ChangeAdcBoxTruckOrTruckLoadDialog', false);
    }
	handleNo(event){
		event && event.preventDefault();
		const self = this;
        this.setState({
            showDialog: false,
        });
		self.props.changeHandleNo(self.state.deliveryMethod);
	}

    componentDidMount() {
		const self = this;
		self.setState({
			showDialog: self.props.showDialog,
			deliveryMethod: self.props.deliveryMethod
		});
    }

	onChangeUpdateParam(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleContinue(event) {
		event.preventDefault();
		const self = this;
		if(self.state.deliveryMethod === "ADC Box Truck"){
			self.props.changeDeliveryMethodADCBoxTruck(self.state.deliveryMethod);
		}else{
			self.props.changeDeliveryMethodADCTruckload(self.state.deliveryMethod);
		}
		
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    render() {
		const self = this;
		const { deliveryMethod } = self.state;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeAdcBoxTruckOrTruckLoadDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order is too large to ship ADC LTL.</p>
					<strong>Would you like to continue with another shipping method?</strong>
					
					{<table className="formTableTypeA">
						<tbody>
							{self.props.state.user.selectedADC === self.props.state.user.defaultSelectedADC && <tr style={{display: "flex", alignItems: "flex-start", gap: "5px", padding:"5px"}}>
									<input type="radio" name="deliveryMethod" id="adcBoxTruck"
										onClick={self.onChangeUpdateParam.bind(this)} 
										checked={deliveryMethod === "ADC Box Truck"} 
										defaultValue="ADC Box Truck"
									/>
									<label htmlFor="adcBoxTruck">
										<strong>ADC Box Truck</strong> shipments are delivered direct with a liftgate to the ground. 
										It does not include uncrating or any installation services. 
										The fee for this service is $300.
									</label>
							</tr>}
							<tr style={{display: "flex", alignItems: "flex-start", gap: "5px", padding:"5px"}}>
									<input type="radio" name="deliveryMethod" id="adcTruckload"
										onClick={self.onChangeUpdateParam.bind(this)} 
										checked={deliveryMethod === "ADC Truckload"} 
										defaultValue="ADC Truckload"
									/>
									<label htmlFor="adcTruckload">
										<strong>ADC Truckload</strong> shipments are tailgate delivery only and cannot include uncrating or any installation services. 
										There is no additional fee for this service.
									</label>
							</tr>
						</tbody>
					</table>}
					<div>
						<div className="noButtonContainer">
							<a className="noButton blueButton" onClick={self.handleNo.bind(this)}>No</a>
						</div>
						{<div className="yesButtonContainer">
							<a className="blueButton yesButton" onClick={self.handleContinue.bind(this)}>Yes</a>
						</div>}
					</div>
                 </div>
            </div>
        );
    }
	
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
});

ChangeAdcBoxTruckOrTruckLoadDialog = connect(mapStateToProps, mapDispatchToProps)(ChangeAdcBoxTruckOrTruckLoadDialog);
export default ChangeAdcBoxTruckOrTruckLoadDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeAdcBoxTruckOrTruckLoadDialog.js